<ion-header>
  <ion-toolbar>
    <ion-back-button slot='start'></ion-back-button>
    <ion-title>Link QR</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div sxCol sxAlign='center' sxDistribution='spaceBetween' sxHeight='full'>
    <div></div>
    <div sxCol sxAlign='center' sxWidth='full'>
      <ion-icon sxColor='white' sxTextSize='300px' name='scan-outline'></ion-icon>
      <p sxColor='white'>Align the QR with scanner</p>
      @if (message) {
      <div sxRadius='10px' sxMargin='0' sxTextSize='16px' sxColor='danger' sxWidth='fill' sxBackground='white'
        sxPadding='20px' sxCol sxDistribution='center' sxAlign='center'>
        <p sxMargin='0' sxTextAlign='center'>{{ message }}</p>
      </div>
      }
    </div>

    <div sxBackground='light' sxWidth='full' sxRadius='30px 30px 0 0' sxPadding='medium'>
      <h3 sxPadding='0 10px'>Scan qid QR standee to link with form</h3>
      <div sxWidth='full' sxMargin='20px 0 0' sxBorderWidth='1px 0 0 0' sxBorderColor='one' sxCenterize='col'>
        <p sxBackground='light' sxMargin='-25px 0 0 0' sxPadding='medium'>Or</p>
      </div>
      <super-button [action]='generateVirtualQr' iconStart='qr-code-outline' background='base' color='three'
        iconEnd='chevron-forward' textAlign='start'>Generate Virtual QR
      </super-button>

      <p class="mt-4 mb-4" sxTextSize='small' sxPadding='0 10px' sxColor='two'>Don't have a QR code standee? Generate a
        virtual QR code
        for easy digital sharing.</p>
    </div>


  </div>


</ion-content>